import { useEffect, useState } from "react";

/**
 * The help library, fetched once as its own chunk the first time anything asks for it.
 *
 * Every screen carries a ?, so importing the articles with the app would put all of their text
 * in the bundle everybody downloads on sign-in, for a page most visits never open.
 */
type Module = typeof import("./library");

let pending: Promise<Module> | null = null;

export function loadHelp(): Promise<Module> {
  if (!pending) {
    pending = import("./library").catch((e: unknown) => {
      // Not cached when it fails: the next ? press tries again rather than failing for ever.
      pending = null;
      throw e;
    });
  }
  return pending;
}

/** The library once loaded; null while loading; "failed" when the chunk could not be fetched. */
export function useHelp(): Module | null | "failed" {
  const [mod, setMod] = useState<Module | null | "failed">(null);
  useEffect(() => {
    let live = true;
    loadHelp().then(
      (m) => live && setMod(m),
      () => live && setMod("failed"),
    );
    return () => {
      live = false;
    };
  }, []);
  return mod;
}
